export default {
  secretarias_executivas: [],
  secretaria_executiva: {
    nome: "",
    pessoa_fisica_id: null,
    cargos: "",
  },
  pagination: {},
};
